import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import UIManifest from "src/engine/ui/UIManifest";
import SyncUtils from "src/engineEditor/props/SyncUtils";
import AutoBind from "src/engine/decorator/AutoBind";
import AutoConfig from "src/engine/decorator/AutoConfig";
import Utils from "src/lib/utils/Utils";
import PropsUtils from "src/engineEditor/props/utils/PropsUtils";

interface IView extends IBaseUI {
    // 是否不要外部div包裹壳
    removeBox?: boolean;
    //是否包含状态值控制
    state?: boolean;

    configProvider?: boolean;

    configConsumer?: boolean;
    transProps?: string[];
    delay?: number;
}
interface IState {
    value?: any;
    render?: boolean;
}

@UIManifest.declareGG(["ggValue", "dataValue", "uiCheck"], "View", "View组件")
class View extends BaseUI<IView, IState> {
    constructor(props: IView) {
        super(props);
        this.state = {};
        this.mrenderUtils.sync("render", () => {
            this.setState({ render: true });
        });
    }

    mSyncUtils = new SyncUtils(10);
    mrenderUtils = new SyncUtils(this.props.delay || 0);

    onChange = (value: any) => {
        this.mSyncUtils.sync("active", () => {
            this.setState({ value });
        });
    };

    @AutoBind
    clearValue() {
        this.setState({ value: undefined });
    }

    componentWillUnmount() {
        this.mSyncUtils.clear("active");
        this.mrenderUtils.clear("render");
    }

    @AutoConfig.Consumer("configConsumer")
    render(props: any = {}) {
        return this.renderItem(props);
    }

    mTarget: any;

    @AutoBind
    target() {
        return this.mTarget;
    }

    getStyle() {
        const style = super.getStyle() || {};
        const { width } = this.props as any;
        if (typeof width !== "undefined") {
            style.width = `${Math.max(95 - Number(width) * 2, 3)}%`;
        }
        return style;
    }

    @AutoBind
    getProp(props: any) {
        const { norenderS = false, classNames = [], id, className = "" } = this.props as any;
        const prop: any = {
            className: `${norenderS ? "_remove_children_flag_" : ""} ${classNames.join(" ")} ${className}`,
            style: this.getStyle(),
        };
        if (id) prop.id = id;
        if (props.onClick) prop.onClick = props.onClick;
        return prop;
    }

    checkView() {
        const { checkView, checkPropsKey } = this.props as any;
        const item = PropsUtils.getValue(this.props, checkPropsKey);
        if (checkView && (typeof item === "undefined" || item === "")) {
            return this.renderChildren(checkView);
        }
        return null;
    }

    @AutoConfig.Provider(["onChange", "target", "state.value,value", "clearValue,clear"], "configProvider", "extList")
    renderItem(props: any = {}) {
        const { delay, configProvider = false, removeBox = false, autoLoading, loading, loadingUI = [], transProps } = this.props as any;
        const prop = this.getProp(props);
        if (configProvider) {
            props.onChange = this.onChange;
            props.state = this.state.value;
            props.clear = this.clearValue;
        }
        if (transProps) {
            for (const key of transProps) {
                props[key] = this.props[key];
            }
        }
        const { render } = this.state;
        let canrender = false;
        if (delay) {
            if (render) {
                canrender = true;
            }
        } else {
            canrender = true;
        }
        return removeBox ? (
            canrender ? (
                this.renderChildren(undefined, props)
            ) : (
                    ""
                )
        ) : (
                <div ref={Utils.ref(this, "mTarget")} {...prop}>
                    {canrender ? this.renderChildren((autoLoading || loading) && loadingUI.length > 0 ? loadingUI : undefined, props) : ""}
                    {this.checkView()}
                </div>
            );

        // return <div style={this.getStyle()}>
        //     {this.renderChildren(buttons,{onSubmit:})}
        // </div>
    }
}

export default View;
